import React from 'react';
import './index.less';

export default function DomainLimit() {
  // starling-disable-next-line
  return <div styleName="domain_limit_wrap">Currently not available in your country or region</div>;
}
